import { FC, MouseEvent, ReactNode, useEffect } from "react";
import { useTranslation } from "react-i18next";

import { REDESIGN_NS } from "../i18n";
import { IconClose } from "./icons";

interface DrawerProps {
  isOpen: boolean;
  title: ReactNode;
  onClose: () => void;
  children: ReactNode;
  footer?: ReactNode;
}

/**
 * Sağdan açılan panel. `Modal`dan ayrı bir bileşen: `Modal` ortalanmış ve sayfa akışında
 * kaydırılan bir kutu, bu ise ekran yüksekliğini kaplayıp kendi içinde kayıyor. z-index
 * modal ile onay modalı ARASINDA: açık bir formun üstünde açılıyor, onay da bunun üstünde.
 */
export const Drawer: FC<DrawerProps> = ({
  isOpen,
  title,
  onClose,
  children,
  footer,
}) => {
  const { t } = useTranslation(REDESIGN_NS);

  useEffect(() => {
    if (!isOpen) return;
    const onKeyDown = (event: KeyboardEvent) => {
      if (event.key === "Escape") onClose();
    };
    document.addEventListener("keydown", onKeyDown);
    return () => document.removeEventListener("keydown", onKeyDown);
  }, [isOpen, onClose]);

  if (!isOpen) return null;

  const stop = (event: MouseEvent) => event.stopPropagation();

  return (
    <div className="sso-rd__drawer-overlay" onClick={onClose} role="presentation">
      <div
        className="sso-rd__drawer"
        onClick={stop}
        role="dialog"
        aria-modal="true"
      >
        <div className="sso-rd__modal-head">
          <div className="sso-rd__modal-title">{title}</div>
          <button
            type="button"
            className="sso-rd__modal-close"
            onClick={onClose}
            title={t("Close")}
            aria-label={t("Close")}
          >
            <IconClose size={18} />
          </button>
        </div>

        <div className="sso-rd__drawer-body">{children}</div>

        {footer}
      </div>
    </div>
  );
};

export default Drawer;
